import { Component, model, ChangeDetectionStrategy } from '@angular/core';

import { InputText } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'csl-text-column-filter',
  standalone: true,
  imports: [InputText, FormsModule],
  templateUrl: './text-column-filter.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './text-column-filter.component.css',
})
export class TextColumnFilterComponent {
  filter = model.required<string>({
    alias: 'filterValue',
  });

  onClear() {
    this.filter.set('');
  }
}
